import React, { Component } from  'react';
import {
  Modal, Button
} from 'react-bootstrap'
import PathView from "./PathView"
import KeyframeParamPanel from "./KeyframeParamPanel"
import '../css/KeyframeModal.css'

class KeyframeModal extends Component {

  render() {

    const recoms = this.props.keyframeModal.recoms;
    const paths = Object.keys(recoms).reduce((paths, transM) => {
      return paths.concat(recoms[transM].map(path => {
        return {
          transM,
          ...path.path,
          recommendations: path.recommendations
        }
      }))
    }, []).filter(path => path.recommendations.length > 0)
      .sort((p1, p2) => {
        return p2.eval.score - p1.eval.score
      })

    return <Modal
      size="lg"
      show={this.props.modalShow}
      onHide={this.props.onHide}
      aria-labelledby="example-modal-sizes-title-lg"
      id="keyframe-modal"
      >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Recommendations
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <KeyframeParamPanel
          params = {this.props.keyframeModal.params}
          stageNList = {[1,2,3]}
          onKeyframeRecomParamChange = {this.props.onKeyframeRecomParamChange}
        />

        {
          paths.length === 0 ?
          <p>There is no available recommendations for given parameters, start, and end charts.</p> :
          ""
        }
        {
        paths.map((path, i) => {
          return <PathView
            sSpec={this.props.keyframeModal.sSpec}
            path={path} pathId = {i} key={`path-${i}`}
            onChangeSequence = {this.props.onChangeSequence}
            onHide={this.props.onHide}
          />
        })
        }


      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={this.props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  }


}

export default KeyframeModal;
